import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Container,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import GlobalHeader from "../../../components/GlobalHeader";
import { useEffect } from "react";
import useApi from "../../../hooks/useApi";
import { useState } from "react";
import SnackAlert from "../../../components/SnackAlert";
import useSnack from "../../../hooks/useSnack";
import styled from "@emotion/styled";

//icons
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import EmailTemplateEditor from "./EmailTemplateEditor";
import Avisos from "./Avisos";

// Secciones colapsables (Accordion): mismo estilo sobrio del resto de la
// página (variant="outlined" en vez de la sombra por defecto de MUI, que
// desentonaría con los bordes planos que ya usan Géneros/Respuestas
// rápidas/etc.). El "&:before" apaga la línea divisoria que MUI dibuja
// entre acordeones apilados, que si no se quita se ve como un doble borde.
const accordionSx = { "&:before": { display: "none" } };

// Una sección colapsable de la página (nivel 2: dentro de otra sección).
const Seccion = ({ titulo, nivel = 1, children }) => (
  <Accordion variant="outlined" disableGutters sx={accordionSx}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant={nivel === 1 ? "h5" : "h6"}>{titulo}</Typography>
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </Accordion>
);


//modulos faqs
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { ident: "-1" }, { ident: "+1" }],
    ["link"],
  ],
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const Personalizar = () => {
  const { loadApi, loadingApi } = useApi();
  const [data, setData] = useState({});
  const [previewImage, setPreviewImage] = useState(null);
  const [previewImageHome, setPreviewImageHome] = useState(null);
  const [editData, setEditData] = useState({});
  const { msgSB, openSB, showSnack, typeSB } = useSnack();

  const [area, setArea] = useState("");
  const [terminos, setTerminos] = useState("");
  const [emailsAvisos, setEmailsAvisos] = useState("");
  const [generos, setGeneros] = useState([]);
  const [nuevoGenero, setNuevoGenero] = useState("");
  const [previewLogoClaro, setPreviewLogoClaro] = useState(null);
  const [previewIcono, setPreviewIcono] = useState(null);
  const [plantillas, setPlantillas] = useState([]);
  const [nuevaPlantilla, setNuevaPlantilla] = useState("");
  // Dónde aplica la plantilla nueva. Por defecto "cancion", que es lo que
  // eran todas hasta ahora.
  const [tipoPlantilla, setTipoPlantilla] = useState("cancion");
  const [encuesta, setEncuesta] = useState(null);
  const [respuestasEncuesta, setRespuestasEncuesta] = useState([]);
  const [nuevaPregunta, setNuevaPregunta] = useState("");
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [editorPlantillaAbierto, setEditorPlantillaAbierto] = useState(false);
  const [plantillaEditando, setPlantillaEditando] = useState(null);

  useEffect(() => {
    loadApi("admin/parametros", true, "get")
      .then((res) => {
        setData(res.data);
        setArea(res.data.faqs);
        setTerminos(res.data.terminos);
        setEmailsAvisos(res.data.emails_avisos || "");
      })
      .catch((error) => {
        showSnack(error.message, "error");
      });
    loadApi("admin/generos", true, "get")
      .then((res) => {
        setGeneros(res.data || []);
      })
      .catch((error) => {
        showSnack(error.message, "error");
      });
    loadApi("admin/respuestas_rapidas", true, "get")
      .then((res) => setPlantillas(res.data || []))
      .catch(() => {});
    loadApi("admin/encuesta", true, "get")
      .then((res) => {
        setEncuesta(res.data.encuesta);
        setRespuestasEncuesta(res.data.respuestas || []);
      })
      .catch(() => {});
    cargarPlantillasCorreo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cargarPlantillasCorreo = () => {
    loadApi("admin/email_templates", true, "get")
      .then((res) => setEmailTemplates(res.data || []))
      .catch(() => {});
  };

  const handleNuevaPlantilla = () => {
    setPlantillaEditando(null);
    setEditorPlantillaAbierto(true);
  };

  const handleEditarPlantilla = (id) => {
    setPlantillaEditando(id);
    setEditorPlantillaAbierto(true);
  };

  // El diálogo se queda abierto después de guardar (antes se cerraba
  // solo): si era una plantilla nueva, pasa a quedar "en edición" con el id
  // recién creado, para que el banner que se acaba de subir se refleje en
  // la vista previa sin tener que reabrir el editor a mano.
  const handlePlantillaGuardada = (id) => {
    if (id) setPlantillaEditando(id);
    cargarPlantillasCorreo();
  };

  const handleActivarPlantilla = (id) => {
    loadApi(`admin/email_templates/${id}/activar`, true, "post")
      .then((res) => {
        showSnack(res.data.message);
        cargarPlantillasCorreo();
      })
      .catch((e) => showSnack(e.message, "error"));
  };

  const handleDuplicarPlantilla = (id) => {
    loadApi(`admin/email_templates/${id}/duplicar`, true, "post")
      .then((res) => {
        showSnack(res.data.message);
        cargarPlantillasCorreo();
      })
      .catch((e) => showSnack(e.message, "error"));
  };

  const handleEliminarPlantilla = (id) => {
    loadApi(`admin/email_templates/${id}`, true, "delete")
      .then((res) => {
        showSnack(res.data.message);
        cargarPlantillasCorreo();
      })
      .catch((e) => showSnack(e.message, "error"));
  };

  //Respuestas rápidas (B3)
  const handleAddPlantilla = () => {
    loadApi("admin/respuestas_rapidas", true, "post", {
      texto: nuevaPlantilla.trim(),
      tipo: tipoPlantilla,
    })
      .then((res) => {
        setPlantillas((prev) => [...prev, res.data.plantilla]);
        setNuevaPlantilla("");
        setTipoPlantilla("cancion");
        showSnack(res.data.message);
      })
      .catch((e) => showSnack(e.message, "error"));
  };
  // Reclasificar una plantilla existente sin tener que reescribir sus 100+
  // caracteres.
  const handleTipoPlantilla = (id, tipo) => {
    loadApi(`admin/respuestas_rapidas/${id}`, true, "put", { tipo })
      .then((res) => {
        setPlantillas((prev) =>
          prev.map((p) => (p.id === id ? { ...p, tipo } : p))
        );
        showSnack(res.data.message);
      })
      .catch((e) => showSnack(e.message, "error"));
  };

  const handleDeletePlantilla = (id) => {
    loadApi(`admin/respuestas_rapidas/${id}`, true, "delete")
      .then((res) => {
        setPlantillas((prev) => prev.filter((p) => p.id !== id));
        showSnack(res.data.message);
      })
      .catch((e) => showSnack(e.message, "error"));
  };

  //Encuesta de satisfacción (C4)
  const handlePublicarEncuesta = () => {
    loadApi("admin/encuesta", true, "post", { pregunta: nuevaPregunta.trim() })
      .then((res) => {
        setEncuesta(res.data.encuesta);
        setRespuestasEncuesta([]);
        setNuevaPregunta("");
        showSnack(res.data.message);
      })
      .catch((e) => showSnack(e.message, "error"));
  };
  const handleCerrarEncuesta = () => {
    loadApi("admin/encuesta", true, "delete")
      .then((res) => {
        setEncuesta(null);
        setRespuestasEncuesta([]);
        showSnack(res.data.message);
      })
      .catch((e) => showSnack(e.message, "error"));
  };

  //Agregar género musical
  const handleAddGenero = () => {
    const nombre = nuevoGenero.trim();
    if (!nombre) {
      showSnack("Escribe un género válido", "warning");
      return;
    }
    loadApi("admin/generos", true, "post", { nombre })
      .then((res) => {
        setGeneros((prev) =>
          [...prev, res.data.genero].sort((a, b) =>
            a.nombre.localeCompare(b.nombre)
          )
        );
        setNuevoGenero("");
        showSnack(res.data.message);
      })
      .catch((e) => {
        showSnack(e.message, "error");
      });
  };

  //Eliminar género musical
  const handleDeleteGenero = (id) => {
    loadApi(`admin/generos/${id}`, true, "delete")
      .then((res) => {
        setGeneros((prev) => prev.filter((genero) => genero.id !== id));
        showSnack(res.data.message);
      })
      .catch((e) => {
        showSnack(e.message, "error");
      });
  };

  //añadir archivo de logo al form
  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    const { name } = e.target;
    const setters = {
      logo: setPreviewImage,
      logo_claro: setPreviewLogoClaro,
      icono: setPreviewIcono,
      home: setPreviewImageHome,
    };
    const setter = setters[name] || setPreviewImageHome;
    if (selectedImage) {
      setter(URL.createObjectURL(selectedImage));
      setEditData((adata) => ({ ...adata, [name]: selectedImage }));
    } else {
      setter(null);
    }
  };

  //update
  const handleSubmit = () => {
    let adata = editData;
    if (area) adata = { ...adata, faqs: area };
    if (terminos) adata = { ...adata, terminos: terminos };
    // Se manda siempre (incluso vacío) para poder dejar la lista sin correos
    adata = { ...adata, emails_avisos: emailsAvisos };
    loadApi("admin/parametros", true, "put", adata, true)
      .then((res) => {
        showSnack(res.data.message);
      })
      .catch((e) => {
        showSnack(e.message, "error");
      });
  };

  return (
    <>
      <GlobalHeader />
      <Container>
        <Stack sx={{ gap: "2rem" }} pb={4}>
          <Accordion variant="outlined" disableGutters sx={accordionSx}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h5">Imágenes de la página</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack sx={{ gap: "2rem" }}>
                <Typography variant="h6">Logo de la pagina</Typography>
                <Typography variant="body2" color="grayText">
                  Se ajusta a este espacio sin recortarse, sin importar sus
                  proporciones. Para mejor resultado usa un PNG con fondo
                  transparente.
                </Typography>
                {/* image logo */}
                <Stack>
                  <Box
                    sx={{
                      position: "relative",
                      width: "200px",
                      height: "200px",
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      bgcolor: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      component="img"
                      src={previewImage || data.logo}
                      sx={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                    <LoadingButton
                      component="label"
                      variant="outlined"
                      sx={{
                        transition: "opacity 0.3s",
                        backgroundColor: "white",
                        backgroundSize: "cover",
                        minWidth: "0%",
                        width: "30px!important",
                        height: "30px!important",
                        position: "absolute",
                        bottom: "4px",
                        right: "4px",
                        zIndex: "10",
                        padding: "0",
                        color: "#666",
                        borderColor: "#666",
                        borderRadius: "50%",
                        ":hover": {
                          backgroundColor: "white",
                          borderColor: "#666",
                          transform: "scale(1.02)",
                        },
                      }}
                    >
                      <AddAPhotoIcon sx={{ width: "18px" }} />
                      <input
                        type="file"
                        onChange={handleImageChange}
                        style={{ width: "100%", height: "100%" }}
                        hidden
                        accept=".png, .jpg, .jpeg, .webp"
                        name="logo"
                      />
                    </LoadingButton>
                  </Box>
                </Stack>
                {/* Logo para fondos claros (login/registro) */}
                <Stack alignItems="flex-start" gap={1}>
                  <Typography variant="h6">Logo para fondos claros</Typography>
                  <Typography variant="body2" color="grayText">
                    Se usa en las pantallas con fondo blanco (inicio de sesión
                    y registro).
                  </Typography>
                  <Box
                    sx={{
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      p: 2,
                      bgcolor: "#ffffff",
                    }}
                  >
                    <img
                      src={
                        previewLogoClaro || data.logo_claro || "/assets/logo.svg"
                      }
                      alt="Logo fondo claro"
                      style={{
                        width: "200px",
                        maxHeight: "200px",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                  <Button
                    component="label"
                    startIcon={<AttachFileIcon />}
                    sx={{ mt: 1 }}
                  >
                    <VisuallyHiddenInput
                      type="file"
                      accept=".jpg, .png, .jpeg"
                      name="logo_claro"
                      onChange={handleImageChange}
                    />
                    Adjuntar
                  </Button>
                </Stack>
                {/* Ícono cuadrado: favicon de la pestaña y vista previa del link */}
                <Stack alignItems="flex-start" gap={1}>
                  <Typography variant="h6">
                    Ícono de la marca (cuadrado)
                  </Typography>
                  <Typography variant="body2" color="grayText">
                    Se usa en el ícono de la pestaña del navegador y en la
                    vista previa al compartir el link (WhatsApp, redes
                    sociales). Súbelo cuadrado y sin texto — solo el símbolo —
                    porque se ve muy chico y un logo con letras queda
                    ilegible. Recomendado: PNG con fondo transparente,
                    512×512. Si no subes ninguno, se usa el logo.
                  </Typography>
                  <Box
                    sx={{
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      p: 2,
                      bgcolor: "#ffffff",
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <img
                      src={previewIcono || data.icono || "/assets/logo.svg"}
                      alt="Ícono de la marca"
                      style={{
                        width: "96px",
                        height: "96px",
                        objectFit: "contain",
                      }}
                    />
                    {/* Cómo se verá realmente en la pestaña del navegador */}
                    <Stack alignItems="center" gap={0.5}>
                      <img
                        src={previewIcono || data.icono || "/assets/logo.svg"}
                        alt="Vista previa en la pestaña"
                        style={{
                          width: "16px",
                          height: "16px",
                          objectFit: "contain",
                        }}
                      />
                      <Typography variant="caption" color="grayText">
                        en la pestaña
                      </Typography>
                    </Stack>
                  </Box>
                  <Button
                    component="label"
                    startIcon={<AttachFileIcon />}
                    sx={{ mt: 1 }}
                  >
                    <VisuallyHiddenInput
                      type="file"
                      accept=".jpg, .png, .jpeg"
                      name="icono"
                      onChange={handleImageChange}
                    />
                    Adjuntar
                  </Button>
                </Stack>
                {/* Personalizar imagen de inicio */}
                <Stack alignItems="flex-start">
                  <Typography variant="h6">
                    Personalizar imagen de inicio/Login
                  </Typography>
                  <Box width="100%" maxWidth="600px">
                    <Box
                      component="img"
                      src={previewImageHome || data?.home}
                      width="100%"
                    />
                  </Box>
                  <Button
                    component="label"
                    startIcon={<AttachFileIcon />}
                    sx={{ mt: 1 }}
                  >
                    <VisuallyHiddenInput
                      type="file"
                      accept=".jpg, .png, .jpeg, .webp"
                      name="home"
                      onChange={handleImageChange}
                    />
                    Adjuntar
                  </Button>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>
          {/* Todo lo que se escribe para comunicarse: avisos, mensaje al
              compartir, respuestas rápidas, correos del equipo y el diseño
              de los correos. */}
          <Seccion titulo="Mensajes">
            <Typography variant="body2" color="grayText" mb={2}>
              Todos los textos que la plataforma les manda a artistas,
              difusores y al equipo.
            </Typography>
            <Stack gap={1}>
              <Seccion nivel={2} titulo="Avisos por notificación, WhatsApp y Telegram">
                <Avisos showSnack={showSnack} />
              </Seccion>
              <Seccion nivel={2} titulo="Mensaje al compartir">
                  <Stack>
                    <Typography variant="body2" color="grayText" mb={2}>
                      Es el texto que acompaña la publicación cuando un difusor
                      comparte lo que aprobó. Hay uno para canciones y otro para
                      eventos.
                    </Typography>
                    <TextField
                      variant="outlined"
                      label="Canciones"
                      // El texto llega después de montar el campo: sin esto la
                      // etiqueta se queda encima del texto.
                      InputLabelProps={{ shrink: true }}
                      defaultValue={data.sharedMessage}
                      onChange={(e) =>
                        setEditData((adata) => ({
                          ...adata,
                          sharedMessage: e.target.value,
                        }))
                      }
                      multiline
                      rows={4}
                      sx={{ width: "100%" }}
                      placeholder="Escriba aqui..."
                      inputProps={{ maxLength: 255 }}
                    ></TextField>
                    <TextField
                      variant="outlined"
                      label="Eventos"
                      // El texto llega después de montar el campo: sin esto la
                      // etiqueta se queda encima del texto.
                      InputLabelProps={{ shrink: true }}
                      defaultValue={data.sharedMessageEvento}
                      onChange={(e) =>
                        setEditData((adata) => ({
                          ...adata,
                          sharedMessageEvento: e.target.value,
                        }))
                      }
                      multiline
                      rows={4}
                      sx={{ width: "100%", mt: 2 }}
                      placeholder="Escriba aqui..."
                      inputProps={{ maxLength: 255 }}
                    ></TextField>
                  </Stack>
              </Seccion>
              <Seccion nivel={2} titulo="Respuestas rápidas de rechazo">
                  {/* Respuestas rápidas para el feedback de rechazo (B3) */}
                  <Stack gap={1}>
                    <Typography variant="body2" color="grayText">
                      Plantillas que el difusor puede elegir como base del feedback al
                      rechazar una canción (mínimo 100 caracteres, editables antes de
                      enviar). Los cambios se aplican al instante.
                    </Typography>
                    <Stack gap={1.5} mt={1}>
                      {plantillas.map((plantilla) => (
                        <Stack
                          key={plantilla.id}
                          direction="row"
                          gap={1}
                          alignItems="flex-start"
                          sx={{
                            border: "1px solid #e0e0e0",
                            borderRadius: 2,
                            p: 1.5,
                          }}
                        >
                          <Stack sx={{ flexGrow: 1 }} gap={0.5}>
                            <Typography variant="body2">{plantilla.texto}</Typography>
                            <TextField
                              select
                              size="small"
                              value={plantilla.tipo || "cancion"}
                              onChange={(e) =>
                                handleTipoPlantilla(plantilla.id, e.target.value)
                              }
                              sx={{ maxWidth: 220 }}
                              SelectProps={{ native: true }}
                            >
                              <option value="cancion">Solo canciones</option>
                              <option value="evento">Solo eventos</option>
                              <option value="ambos">Ambos</option>
                            </TextField>
                          </Stack>
                          <Button
                            color="error"
                            size="small"
                            onClick={() => handleDeletePlantilla(plantilla.id)}
                          >
                            Eliminar
                          </Button>
                        </Stack>
                      ))}
                      {plantillas.length === 0 && (
                        <Typography variant="body2" color="grayText">
                          Aún no hay respuestas rápidas.
                        </Typography>
                      )}
                    </Stack>
                    <TextField
                      multiline
                      rows={3}
                      value={nuevaPlantilla}
                      onChange={(e) => setNuevaPlantilla(e.target.value)}
                      placeholder="Escribe una nueva respuesta rápida (mínimo 100 caracteres)..."
                      helperText={`${nuevaPlantilla.length}/1000 caracteres (mínimo 100)`}
                      inputProps={{ maxLength: 1000 }}
                    />
                    <Stack direction="row" gap={2} alignItems="center" flexWrap="wrap">
                      <TextField
                        select
                        size="small"
                        label="Aplica a"
                        value={tipoPlantilla}
                        onChange={(e) => setTipoPlantilla(e.target.value)}
                        sx={{ minWidth: 200 }}
                        SelectProps={{ native: true }}
                      >
                        <option value="cancion">Solo canciones</option>
                        <option value="evento">Solo eventos</option>
                        <option value="ambos">Ambos</option>
                      </TextField>
                      <LoadingButton
                        loading={loadingApi.includes("post__admin/respuestas_rapidas")}
                        onClick={handleAddPlantilla}
                        disabled={nuevaPlantilla.trim().length < 100}
                      >
                        Agregar respuesta rápida
                      </LoadingButton>
                    </Stack>
                  </Stack>
              </Seccion>
              <Seccion nivel={2} titulo="Correos del equipo">
                  {/* Avisos internos al equipo por registros nuevos */}
                  <Stack>
                    <Typography variant="body2" color="grayText" mb={2}>
                      Los avisos al equipo que llevan correo (registros nuevos,
                      difusores por verificar, solicitudes de 5 RC, reportes y
                      correcciones entregadas) les llegan siempre a las cuentas de
                      administrador. Aquí puedes agregar correos extra, separados por
                      coma. Para recibirlos también por WhatsApp, registra tu número en
                      la sección WhatsApp.
                    </Typography>
                    <TextField
                      variant="outlined"
                      label="Correos extra (separados por coma)"
                      value={emailsAvisos}
                      onChange={(e) => setEmailsAvisos(e.target.value)}
                      multiline
                      rows={2}
                      sx={{ width: "100%" }}
                      placeholder="equipo@radarfreim.com, verificaciones@radarfreim.com"
                    />
                  </Stack>
              </Seccion>
              <Seccion nivel={2} titulo="Diseño de los correos">
                  {/* Plantillas visuales de correo: banner, logo, colores y pie que
                      envuelven los correos que envía la plataforma (verificación,
                      avisos, boletín...). El contenido de cada correo sigue siendo
                      código; esto solo administra lo que lo rodea. Sección
                      independiente del botón "Guardar" de abajo — cada acción aquí
                      se guarda al instante, igual que Géneros o Respuestas rápidas. */}
                  <Stack gap={1}>
                    <Typography variant="body2" color="grayText">
                      Personaliza el banner, el logo, los colores y el pie de los
                      correos que envía Radar Freim (verificación, avisos, retiros,
                      boletín...). Solo una plantilla puede estar activa a la vez;
                      mientras no actives ninguna, los correos se ven igual que
                      siempre.
                    </Typography>
                    <Stack gap={1.5} mt={1}>
                      {emailTemplates.map((plantilla) => (
                        <Stack
                          key={plantilla.id}
                          direction="row"
                          gap={1}
                          alignItems="center"
                          sx={{
                            border: "1px solid #e0e0e0",
                            borderRadius: 2,
                            p: 1.5,
                          }}
                        >
                          <Typography variant="body2" sx={{ flexGrow: 1 }}>
                            {plantilla.nombre}
                          </Typography>
                          {plantilla.activa && (
                            <Chip label="Activa" color="success" size="small" />
                          )}
                          {!plantilla.activa && (
                            <Button
                              size="small"
                              onClick={() => handleActivarPlantilla(plantilla.id)}
                            >
                              Activar
                            </Button>
                          )}
                          <Button
                            size="small"
                            onClick={() => handleEditarPlantilla(plantilla.id)}
                          >
                            Editar
                          </Button>
                          <Button
                            size="small"
                            onClick={() => handleDuplicarPlantilla(plantilla.id)}
                          >
                            Duplicar
                          </Button>
                          <Button
                            size="small"
                            color="error"
                            disabled={plantilla.activa}
                            onClick={() => handleEliminarPlantilla(plantilla.id)}
                          >
                            Eliminar
                          </Button>
                        </Stack>
                      ))}
                      {emailTemplates.length === 0 && (
                        <Typography variant="body2" color="grayText">
                          Aún no hay plantillas de correo.
                        </Typography>
                      )}
                    </Stack>
                    <Stack direction="row">
                      <Button onClick={handleNuevaPlantilla} sx={{ mt: 1 }}>
                        Nueva plantilla
                      </Button>
                    </Stack>
                  </Stack>
              </Seccion>
            </Stack>
          </Seccion>
          <Accordion variant="outlined" disableGutters sx={accordionSx}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h5">Géneros musicales</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="grayText" mb={2}>
                Estos géneros se ofrecen en los formularios de artistas y
                difusores. Eliminar un género no afecta los perfiles que ya lo
                tienen guardado. Los cambios se aplican al instante.
              </Typography>
              <Stack direction="row" spacing={1} mb={2} maxWidth="510px">
                <TextField
                  variant="outlined"
                  label="Nuevo género"
                  value={nuevoGenero}
                  fullWidth
                  onChange={(e) => setNuevoGenero(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleAddGenero();
                  }}
                />
                <LoadingButton
                  loading={loadingApi.includes("post__admin/generos")}
                  onClick={handleAddGenero}
                  sx={{ px: 3 }}
                >
                  Agregar
                </LoadingButton>
              </Stack>
              <Stack direction="row" flexWrap="wrap" gap={1}>
                {generos.map((genero) => (
                  <Chip
                    key={genero.id}
                    label={genero.nombre}
                    onDelete={() => handleDeleteGenero(genero.id)}
                  />
                ))}
              </Stack>
            </AccordionDetails>
          </Accordion>
          <Seccion titulo="Encuesta de satisfacción">
              {/* Encuesta de satisfacción (C4) */}
              <Stack gap={1}>
                <Typography variant="body2" color="grayText">
                  Publica una pregunta y todos los usuarios la verán al entrar (una
                  sola vez cada uno). Publicar una nueva cierra la anterior.
                </Typography>
                {encuesta ? (
                  <Stack
                    gap={1}
                    sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2 }}
                  >
                    <Typography variant="subtitle1" fontWeight={600}>
                      Pregunta activa: {encuesta.pregunta}
                    </Typography>
                    <Typography variant="body2" color="grayText">
                      {respuestasEncuesta.length} respuesta(s) recibida(s)
                    </Typography>
                    <Stack gap={1} sx={{ maxHeight: "300px", overflowY: "auto" }}>
                      {respuestasEncuesta.map((r) => (
                        <Stack
                          key={r.id}
                          sx={{ bgcolor: "#f7f7f7", borderRadius: 1.5, p: 1.2 }}
                        >
                          <Typography variant="caption" color="grayText">
                            {r.nombre} ({r.email}) — {r.rol}
                          </Typography>
                          <Typography variant="body2">{r.respuesta}</Typography>
                        </Stack>
                      ))}
                    </Stack>
                    <Stack direction="row">
                      <Button color="warning" onClick={handleCerrarEncuesta}>
                        Cerrar encuesta
                      </Button>
                    </Stack>
                  </Stack>
                ) : (
                  <Typography variant="body2" color="grayText">
                    No hay ninguna encuesta activa.
                  </Typography>
                )}
                <TextField
                  value={nuevaPregunta}
                  onChange={(e) => setNuevaPregunta(e.target.value)}
                  placeholder="Ej: ¿Qué tan satisfecho estás con Radar Freim y qué mejorarías?"
                />
                <Stack direction="row">
                  <LoadingButton
                    loading={loadingApi.includes("post__admin/encuesta")}
                    onClick={handlePublicarEncuesta}
                    disabled={!nuevaPregunta.trim()}
                  >
                    Publicar pregunta
                  </LoadingButton>
                </Stack>
              </Stack>
          </Seccion>
          <Seccion titulo="Preguntas frecuentes">
              <Stack minHeight="300px">
                <Box>
                  <ReactQuill
                    value={area}
                    theme="snow"
                    onChange={setArea}
                    modules={modules}
                  />
                </Box>
              </Stack>
          </Seccion>
          <Seccion titulo="Términos y condiciones">
              <Stack>
                <Box>
                  <ReactQuill
                    value={terminos}
                    theme="snow"
                    onChange={setTerminos}
                    modules={modules}
                  />
                </Box>
              </Stack>
          </Seccion>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="flex-end"
            alignItems={{ sm: "center" }}
            gap={2}
          >
            <Typography variant="caption" color="grayText" textAlign="right">
              Guarda las imágenes, el mensaje al compartir, los correos del
              equipo, las preguntas frecuentes y los términos. Lo demás se
              guarda al instante.
            </Typography>
            <LoadingButton
              loading={loadingApi.includes("put__admin/parametros")}
              sx={{ px: "28px" }}
              onClick={handleSubmit}
            >
              Guardar
            </LoadingButton>
          </Stack>
        </Stack>
      </Container>
      <EmailTemplateEditor
        open={editorPlantillaAbierto}
        templateId={plantillaEditando}
        onClose={() => setEditorPlantillaAbierto(false)}
        onGuardado={handlePlantillaGuardada}
      />
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
};

export default Personalizar;
